import {AppFunction, Template} from "../misc/types";
import View from "../framework/view";
import {RrWebView} from "../views/rrweb";
import blank from "../../pugc/blank-page";

export class RrWebFunction extends AppFunction {

    readonly v : View;

    readonly session: string;

    constructor(session: string) {
        super();
        this.session = session;
        this.v = new RrWebView(session);
    }

    view() {
        return this.v;
    }
    url() {
        return `/rrweb/${this.session}`;
    }

    pageTemplate(): Template | undefined {
        return blank;
    }

}
